import BeefreeSDK from "@beefree.io/sdk";
import { beefreeOptionType } from "../components/BeefreeEditor/BeefreeEditor";
import centralApi from "../services/centralApi";
import { API_ENDPOINTS } from "utils/constants";

export const beefree = async (options: beefreeOptionType , config :any ) => {
  try {
    // Call backend route to get Beefree token
    const response = await centralApi(
      "POST",
      API_ENDPOINTS.BEEFREE_TOKEN_URL,config
    );
    const tokenData = response;

    //simple Beefree application configuration...
    var conf: any = {
      container: "bee-plugin-container",
      trackChanges: true, // boolean
      mergeTags:options?.mergeTags || [],
      loadingSpinnerDisableOnSave: true
    };
    const bee = new BeefreeSDK(tokenData);
    bee.start(
      conf,
      options?.existingTemplate ? JSON.parse(options?.existingTemplate) : {}
    );
    conf.onSave = options.workspace?.onSave;
    conf.onChange = options.workspace?.onChange;
    conf.onSaveAsTemplate = options.workspace?.onSaveAsTemplate;
    conf.onAutoSave = options.workspace?.onAutoSave;
    conf.onSend = options.workspace?.onSend;
    conf.onLoad = options.workspace?.onLoad;
    conf.onError = options.workspace?.onError;
    return {instance:bee,conf:conf}
  } catch (error) {}
};
